import isNumber from 'lodash/isNumber';
import find from 'lodash/find';

import $store from './StoreService.js';
import Constants from '~/config/Constants';

export default class ToastService {
  static add(options: {
    title: string,
    icon?: string,
    type?: string,
    time?: number,
    dataTestid?: string,
  }) {
    const timeToastWillBeVisibleFor = isNumber(options.time) ? options.time : 3000;

    const toasts = $store().getters['root/toasts'];

    if (!find(toasts, item => item.title === options.title)) {
      $store().dispatch('root/pushToast', options);

      setTimeout(() => {
        $store().dispatch('root/shiftToast');
      }, timeToastWillBeVisibleFor);
    }
  }
}

export function successToast(title: string) {
  ToastService.add({
    type: Constants.ToastTypes.SUCCESS,
    icon: 'fas fa-check-circle',
    title,
  });
}

export function failureToast(title: string) {
  ToastService.add({
    type: Constants.ToastTypes.ERROR,
    icon: 'fas fa-times-circle',
    title,
  });
}
